export type QuackchatHomeLayoutConfiguration = {
  enabled: boolean;
  greeting: {
    enabled: boolean;
    title: string;
    fallbackUserName: string;
  };
  supportTickets: {
    enabled: boolean;
    style: "list" | "carousel";
    statusesToDisplayOnThePage: string[];
    endUserTicketName: string;
    allowUserReplyToTicket: boolean;
  };
  askAiInput: {
    enabled: boolean;
    placeholder: string;
  };
};

export const defaultQuackchatHomeLayoutConfiguration: QuackchatHomeLayoutConfiguration =
  {
    enabled: false,
    greeting: {
      enabled: true,
      title: "Hello {USER}",
      fallbackUserName: "there",
    },
    askAiInput: {
      enabled: true,
      placeholder: "Ask anything...",
    },
    supportTickets: {
      enabled: true,
      style: "list",
      statusesToDisplayOnThePage: [],
      endUserTicketName: "Support Cases",
      allowUserReplyToTicket: false,
    },
  };

export function normalizeQuackchatHomeLayoutConfiguration(
  configuration?: Partial<QuackchatHomeLayoutConfiguration> | null
): QuackchatHomeLayoutConfiguration {
  const enabled: boolean = configuration?.enabled ?? true;
  const greeting: Partial<QuackchatHomeLayoutConfiguration["greeting"]> =
    configuration?.greeting ?? {};
  const askAiInput: Partial<QuackchatHomeLayoutConfiguration["askAiInput"]> =
    configuration?.askAiInput ?? {};
  const supportTickets: Partial<
    QuackchatHomeLayoutConfiguration["supportTickets"]
  > = configuration?.supportTickets ?? {};
  const statusesToDisplayOnThePage = Array.isArray(
    supportTickets.statusesToDisplayOnThePage
  )
    ? supportTickets.statusesToDisplayOnThePage
    : [];

  return {
    enabled: enabled,
    greeting: {
      enabled: greeting.enabled ?? true,
      title: greeting.title ?? "Hello {USER}",
      fallbackUserName: greeting.fallbackUserName ?? "there",
    },
    askAiInput: {
      enabled: askAiInput.enabled ?? true,
      placeholder: askAiInput.placeholder ?? "Ask anything...",
    },
    supportTickets: {
      enabled: supportTickets.enabled ?? true,
      style: supportTickets.style ?? "list",
      statusesToDisplayOnThePage,
      endUserTicketName: supportTickets.endUserTicketName ?? "Support Cases",
      allowUserReplyToTicket: supportTickets.allowUserReplyToTicket ?? false,
    },
  };
}
